import React, { Component } from 'react';
import { graphql, compose } from 'react-apollo';
import ImageUploader from 'react-images-upload';
import PropTypes from 'prop-types';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import { FaEdit } from 'react-icons/fa';
// core components
import GridItem from '../../../components/Grid/GridItem';
import GridContainer from '../../../components/Grid/GridContainer';
import Button from '../../../components/CustomButtons/Button';
import Card from '../../../components/Card/Card';
import CardHeader from '../../../components/Card/CardHeader';
import CardAvatar from '../../../components/Card/CardAvatar';
import CardBody from '../../../components/Card/CardBody';
import CardFooter from '../../../components/Card/CardFooter';
import CustomInput from '../../../components/CustomInput/CustomInput';
import { getAdminById } from './queries';
import { getAllAdmin } from '../TableAdmin/queries';
import { updateAdmin, resetAdminPassword } from './mutation';
import styles from './style';
import config from '../../../config';
import { Dialog } from '../../../components';

class Detail extends Component {
  constructor(props) {
    super(props);
    const { detailAdmin } = this.props;
    this.state = {
      edit: false,
      username: detailAdmin ? detailAdmin.username : '',
      avatar: detailAdmin ? detailAdmin.avatar : '',
      email: detailAdmin ? detailAdmin.email : '',
      location: detailAdmin ? detailAdmin.location : '',
      telephone: detailAdmin ? detailAdmin.telephone : '',
      firstName: detailAdmin ? detailAdmin.firstName : '',
      lastName: detailAdmin ? detailAdmin.lastName : '',
      role: detailAdmin ? detailAdmin.role : 'ADMIN',
      password: '',
      confirmPassword: '',
      fileUpLoad: [],
      nameImage: '',
      open: false,
      titleDialog: '',
      content: '',
      resetPasswordOpen: false,
      temporaryPassword: '',
      confirmTemporaryPassword: '',
    };
  }

  componentWillReceiveProps = (nextProps) => {
    const { detailAdmin } = this.props;
    if (nextProps.detailAdmin !== detailAdmin) {
      const { detailAdmin } = nextProps;
      this.setState({
        username: detailAdmin.username,
        avatar: detailAdmin.avatar,
        email: detailAdmin.email,
        location: detailAdmin.location,
        telephone: detailAdmin.telephone,
        firstName: detailAdmin.firstName,
        lastName: detailAdmin.lastName,
        role: detailAdmin.role || 'ADMIN',
      });
    }
  }

  onEdit = () => {
    const { edit } = this.state;
    this.setState({ edit: !edit });
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  onChooseImage = (images) => {
    this.setState({ fileUpLoad: images, nameImage: images[0].name });
  }

  onResetPassword = () => {
    this.setState({ resetPasswordOpen: true, temporaryPassword: '', confirmTemporaryPassword: '' });
  }

  onCloseResetPassword = () => {
    this.setState({ resetPasswordOpen: false, temporaryPassword: '', confirmTemporaryPassword: '' });
  }

  onSaveResetPassword = () => {
    const { temporaryPassword, confirmTemporaryPassword } = this.state;
    const { match, resetAdminPassword } = this.props;
    const { id } = match.params;

    if (!temporaryPassword || temporaryPassword.length < 6) {
      this.setState({
        open: true,
        content: 'Password must be at least 6 characters',
        titleDialog: 'Error',
      });
      return;
    }

    if (temporaryPassword !== confirmTemporaryPassword) {
      this.setState({
        open: true,
        content: 'Passwords do not match',
        titleDialog: 'Error',
      });
      return;
    }

    resetAdminPassword({
      variables: {
        id: parseInt(id, 10),
        temporaryPassword,
      },
      refetchQueries: [{ query: getAdminById, variables: { id: parseInt(id, 10) } }],
    }).then(() => {
      this.setState({
        resetPasswordOpen: false,
        temporaryPassword: '',
        confirmTemporaryPassword: '',
        open: true,
        content: 'Password reset successfully. User must change password on next login.',
        titleDialog: 'Success',
      });
    }).catch(({ graphQLErrors }) => {
      if (graphQLErrors) {
        this.setState({
          open: true,
          content: graphQLErrors[0].message || 'Error resetting password',
          titleDialog: 'Error',
        });
      }
    });
  }

  onSaveProfile = async () => {
    const {
      username, email, location, telephone, firstName, lastName, role, password, confirmPassword, fileUpLoad,
    } = this.state;
    const { match, updateAdmin, allAdmins, detailAdmin } = this.props;
    let { avatar } = this.state;

    if (password && password !== confirmPassword) {
      this.setState({
        open: true,
        content: 'Passwords do not match',
        titleDialog: 'Error',
      });
      return;
    }

    if (fileUpLoad.length > 0) {
      const files = Array.from(fileUpLoad);
      const formData = new FormData();
      files.forEach((file, i) => {
        formData.append(i, file);
      });

      await fetch(`${config.upload}`, {
        method: 'POST',
        body: formData,
      })
        .then(res => res.json())
        .then((images) => {
          // console.log(images);
          avatar = images.file.uri;
        });
    }
    const { id } = match.params;

    const integerId = parseInt(id, 10);

    const currentUsername = localStorage.getItem('username');
    const currentUser = allAdmins && allAdmins.find(admin => admin.username === currentUsername);
    const isAdminUser = currentUser && currentUser.role === 'ADMIN';

    const input = {
      username, email, location, telephone, firstName, lastName, avatar, id: integerId,
    };

    // Solo los ADMIN pueden enviar cambios de rol
    if (isAdminUser) {
      input.role = role;
    }

    if (isAdminUser && password) {
      input.password = password;
    }

    updateAdmin({
      variables: {
        input,
      },
      refetchQueries: [{ query: getAdminById, variables: { id } }, { query: getAllAdmin }],
    }).then((res) => {
      if (res) {
        this.setState({
          fileUpLoad: [],
          edit: false,
          open: true,
          content: 'Completed',
          titleDialog: 'Update Admin',
          password: '',
          confirmPassword: '',
        });
      }
    }).catch(({ graphQLErrors }) => {
      if (graphQLErrors) {
        this.setState({ open: true, content: graphQLErrors[0].message || 'Value invalid', titleDialog: 'Erros Update Admin' });
      }
    });
  }

  render() {
    const { classes, loading, detailAdmin, allAdmins } = this.props;
    if (loading) return null;
    const {
      edit, username, avatar, email, location, telephone, firstName, lastName, role, password, confirmPassword, fileUpLoad, nameImage, content, titleDialog, open, resetPasswordOpen, temporaryPassword, confirmTemporaryPassword,
    } = this.state;
    
    const currentUsername = localStorage.getItem('username');
    const currentUser = allAdmins && allAdmins.find(admin => admin.username === currentUsername);
    const canChangePassword = currentUser && currentUser.role === 'ADMIN';
    const canChangeRole = canChangePassword;

    return (
      <div>
        <GridContainer>
          <Dialog
            title={titleDialog}
            content={content}
            open={open}
            onOk={() => this.setState({ open: false })}
          />
          <Dialog
            title="Reset Password"
            content={(
              <div>
                <CustomInput
                  labelText="Temporary Password"
                  id="temporaryPassword"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    type: 'password',
                    value: temporaryPassword,
                    name: 'temporaryPassword',
                    onChange: this.handleChange,
                    placeholder: 'Enter temporary password (min 6 characters)',
                  }}
                />
                <CustomInput
                  labelText="Confirm Temporary Password"
                  id="confirmTemporaryPassword"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    type: 'password',
                    value: confirmTemporaryPassword,
                    name: 'confirmTemporaryPassword',
                    onChange: this.handleChange,
                    placeholder: 'Confirm temporary password',
                  }}
                />
              </div>
            )}
            open={resetPasswordOpen}
            onOk={this.onSaveResetPassword}
            onCancel={this.onCloseResetPassword}
            okText="Reset Password"
            cancelText="Cancel"
          />
          <GridItem xs={12} sm={12} md={8}>
            <Card>
              <CardHeader className={classes.headCard}>
                <h4 className={classes.cardTitleWhite}>{ edit ? 'Edit Profile' : 'Profile'}</h4>
                { edit ? <p className={classes.cardCategoryWhite}>Complete your profile</p> : null }
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={5}>
                    <CustomInput
                      labelText="Username"
                      id="username"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: !edit,
                        value: username,
                        name: 'username',
                        onChange: this.handleChange,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="First Name"
                      id="firstName"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: !edit,
                        value: firstName || '',
                        name: 'firstName',
                        onChange: this.handleChange,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <CustomInput
                      labelText="Last Name"
                      id="lastName"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: !edit,
                        value: lastName || '',
                        name: 'lastName',
                        onChange: this.handleChange,
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText="Email"
                      id="email"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: !edit,
                        value: email || '',
                        name: 'email',
                        onChange: this.handleChange,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <CustomInput
                      labelText="Telephone"
                      id="telephone"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: !edit,
                        value: telephone || '',
                        name: 'telephone',
                        onChange: this.handleChange,
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={8}>
                    <CustomInput
                      labelText="Location"
                      id="location"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        disabled: !edit,
                        value: location || '',
                        name: 'location',
                        onChange: this.handleChange,
                      }}
                    />
                  </GridItem>
                </GridContainer>
                {edit && canChangePassword &&  (
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={6}>
                      <FormControl fullWidth>
                        <InputLabel>Role</InputLabel>
                        <Select
                          value={role}
                          onChange={this.handleChange}
                          name="role"
                          disabled={!edit || !canChangeRole}
                        >
                          <MenuItem value="ADMIN">Admin</MenuItem>
                          <MenuItem value="SELLER">Seller</MenuItem>
                        </Select>
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                )}
                {edit && canChangePassword && (
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={6}>
                      <CustomInput
                        labelText="New Password"
                        id="password"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: 'password',
                          disabled: !edit,
                          value: password,
                          name: 'password',
                          onChange: this.handleChange,
                          placeholder: 'Leave empty to keep current password',
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <CustomInput
                        labelText="Confirm Password"
                        id="confirmPassword"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: 'password',
                          disabled: !edit,
                          value: confirmPassword,
                          name: 'confirmPassword',
                          onChange: this.handleChange,
                          placeholder: 'Confirm new password',
                        }}
                      />
                    </GridItem>
                  </GridContainer>
                )}
                {/* <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <InputLabel style={{ color: "#AAAAAA" }}>About me</InputLabel>
                    <CustomInput
                      labelText="Lamborghini Mercy, Your chick she so thirsty, I'm in that two seat Lambo."
                      id="about-me"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        multiline: true,
                        rows: 5
                      }}
                    />
                  </GridItem>
                </GridContainer> */}
              </CardBody>
              {
                edit
                  ? (
                    <CardFooter>
                      <Button className={classes.button} onClick={this.onSaveProfile}>Update Profile</Button>
                    </CardFooter>
                  ) : null
              }
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <Card profile>
              <CardAvatar profile>
                <Avatar alt="Avartar" src={avatar} className={classes.avatar} />
              </CardAvatar>
              {
                  edit
                    ? (
                      <ImageUploader
                        withIcon={false}
                        buttonText="Choose images"
                        label={`New Image: ${nameImage}`}
                        withLabel={fileUpLoad.length > 0}
                        onChange={this.onChooseImage}
                        imgExtension={['.jpg', '.gif', '.png', '.gif']}
                        maxFileSize={5242880}
                        fileContainerStyle={styles.uploadImage}
                        buttonStyles={styles.buttonUpload}
                        singleImage
                      />
                    ) : null
              }
              <CardBody profile>
                <h6 className={classes.cardCategory}>{role || 'ADMIN'}</h6>
                <h4 className={classes.cardTitle}>{username.toUpperCase()}</h4>
                {/* <p className={classes.description}>
                  Don't be scared of the truth because we need to restart the
                  human foundation in truth And I love you like Kanye loves Kanye
                  I love Rick Owens’ bed design but the back is...
                </p> */}
                <Button round className={classes.button} onClick={this.onEdit}>
                  <Typography component="p" className={classes.text}>{!edit ? 'Edit' : 'Cancel'}</Typography>
                  <FaEdit color="#ffffff" size={16} />
                </Button>
                {canChangePassword && !edit && (
                  <Button round className={classes.button} onClick={this.onResetPassword} style={{ marginTop: '10px', backgroundColor: '#f44336' }}>
                    <Typography component="p" className={classes.text}>Reset Password</Typography>
                  </Button>
                )}
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

// Mark: defaultProps
Detail.defaultProps = {
  classes: {},
  detailAdmin: {},
  allAdmins: [],
  loading: false,
  match: {},
  updateAdmin: () => {},
  resetAdminPassword: () => {},
};

// Mark: PropsType
Detail.propTypes = {
  classes: PropTypes.object,
  detailAdmin: PropTypes.object,
  allAdmins: PropTypes.array,
  loading: PropTypes.bool,
  match: PropTypes.object,
  updateAdmin: PropTypes.func,
  resetAdminPassword: PropTypes.func,
};

// Mark: Map data grapql to props
const DetailAdminrById = graphql(getAdminById, {
  props: ({ data }) => ({
    loading: data.loading,
    detailAdmin: data.getAdminById,
  }),
  options: (props) => {
    return ({ variables: { id: Number(props.match.params.id) }, fetchPolicy: 'cache-and-network' });
  },
});

const AllAdmins = graphql(getAllAdmin, {
  props: ({ data }) => ({
    allAdmins: data.getAllAdmin || [],
  }),
});

const Update = graphql(updateAdmin, { name: 'updateAdmin' });
const ResetPassword = graphql(resetAdminPassword, { name: 'resetAdminPassword' });

export default withStyles(styles)(compose(DetailAdminrById, AllAdmins, Update, ResetPassword)(Detail));
